export default {"src":"/_next/static/media/letterD.c8c47b72.svg","height":73,"width":64,"blurWidth":0,"blurHeight":0};